import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { AutenticacaoService } from './autenticacao.service';
import { Usuario } from './modelos/usuario';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private autenticacaoService: AutenticacaoService) { }

  consultarUsuario(): Usuario {
      try {
        let autenticacao = this.autenticacaoService.consultarAutenticacao();

        if(autenticacao === null)
          throw 'autenticacao null.';

          let r = jwtDecode(autenticacao.token.token) as Usuario;

          r.profissionalProfissaoTipo = +r.profissionalProfissaoTipo;
          r.profissionalTipoAssinatura = +(r.profissionalTipoAssinatura ?? 1);
          r.empresaId = +r.empresaId;
          r.id = +r.id;
          r.profissionalId = +r.profissionalId;

          return r;

      } catch (error) {
          throw error;
      }
  }
}
